export default __webpack_public_path__ + "static/media/uploader-abbottLite-problem-2.fb8de1d3.png";